import roadMapImage1 from 'assets/images/roadmap_1.svg';
import roadMapImage2 from 'assets/images/roadmap_2.svg';
import roadMapImage3 from 'assets/images/roadmap_3.svg';

export const ROADMAP = [
  {
    image: roadMapImage1,
    title: 'Start with the Heart',
    description: `Center people in conceptualizing products. Think of their pain points and set out to create solutions that fit them.`,
  },
  {
    image: roadMapImage2,
    title: 'Use the Data as a Map',
    description: `Collect and work with valuable data while building products. Let it guide the process and inform decisions.`,
  },
  {
    image: roadMapImage3,
    title: 'Co-create',
    description: `Work together to bring products to life. Contribute your part to the team's process and always execute.`,
  },
];
